'use strict'

import { FetchEntregaClient } from './fetchEntrega'
const commonService = {
  getV3Config () {
    return FetchEntregaClient.fetchEntrega({
      method: 'GET',
      url: '/v1/config/v3_configure'
    })
  },
  getEntregaWihteList (params) {
    return FetchEntregaClient.fetchEntrega({
      method: 'GET',
      url: 'https://b2b-api.99app.com/ride/v1/B2C/config',
      headers: params?.headers
    })
  },

  getCxConfig (params) {
    return FetchEntregaClient.fetchEntrega({
      method: 'GET',
      url: 'https://b2b-api.99app.com/ride/v1/CX/config',
      headers: params?.headers
    })
  }
}

export default commonService
